var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1803 15.7672L19.1254 14.6866C20.8399 13.7341 20.8399 11.2683 19.1254 10.3158L17.1802 9.23516L16.2071 10.2083L16.1919 10.2232L13.8148 12.5012L16.1919 14.7792L16.2071 14.7941L17.1803 15.7672ZM12.3696 13.8863L14.8004 16.2158L15.362 16.7774L5.71411 22.1373C5.02468 22.5203 4.26996 22.5386 3.62199 22.2934L4.19957 21.7158L12.3696 13.8863ZM12.3696 11.1161L14.8004 8.78657L15.362 8.225L5.71411 2.86508C5.02469 2.48207 4.26997 2.46378 3.622 2.70898L4.19957 3.28655L12.3696 11.1161ZM2.1841 4.09951L2.79289 4.7083L2.80809 4.72318L10.9243 12.5012L2.80809 20.2792L2.79289 20.2941L2.1841 20.9029C2.06606 20.614 2 20.2943 2 19.9519V5.05047C2 4.7081 2.06606 4.38835 2.1841 4.09951Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayBtn);
export default __webpack_public_path__ + "static/media/play_btn.ed6d34790ba4ca57cc4c9c2527f87205.svg";
export { ForwardRef as ReactComponent };